import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { useInteriorDamageImages } from '../../hooks/useInteriorDamageImages';
import { useViewVehicleContext } from 'pages/Admin/ViewVehicle/context/ViewVehicleContext';

export const InteriorDamaged = () => {
  const damagedImages = useInteriorDamageImages();
  const { publicView } = useViewVehicleContext();

  if (damagedImages.length === 0) return <div style={{ flex: '1 1 200%' }} />;

  return (
    <Level2Wrapper flex="1 1 200%" label="Damage">
      <ImageList layoutSize={publicView ? 'md' : 'lg'} label="Damage Pictures" images={damagedImages} />
    </Level2Wrapper>
  );
};
